import { useLayoutEffect } from "react";

// Grows a textarea to fit its content, up to maxHeight, then lets it scroll.
// No fixed/hardcoded height - starts at the natural single-line height and
// expands only as content (or a Shift+Enter newline) requires it.
export function useAutoResizeTextarea(ref, value, maxHeight = 120) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`;
  }, [ref, value, maxHeight]);
}

export default useAutoResizeTextarea;
